import { TBoardId } from '../../types/types';

export const getBoardIdFromUrl = (
    url: string
): TBoardId => {
    const board = url.match(/\/d-\d{16}$/);
    return board && Number(board[0].slice(3));
}
